import React from 'react';
import './SmallLoader.css';

function SmallLoader() {
  return (
    <div className="small-loader">
      <div className="dot-flashing"></div>
    </div>
  );
}

export default SmallLoader;
